"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SLC_CLASSIC_AGREEMENTS_CONTENT = exports.SLC_AGREEMENTS_MODAL_CONTENT = exports.FA_SLC_CONFIRM_SCHEDULE_CONTENT = exports.CLASSIC_SLC_CONFIRM_SCHEDULE_CONTENT = exports.SLC_CONFIRM_SCHEDULE_CONTENT = void 0;
exports.SLC_CONFIRM_SCHEDULE_CONTENT = {
    HEADER: 'Your schedule is ready',
    SUB_HEADER: {
        FLEX_ANYWHERE: 'Confirm your schedule and add a payment method.',
        AUTOPAY_ON: 'Confirm your schedule and add a default payment method. Since rent autopay is on, we’ll start with your {{month}} rent bill.',
        AUTOPAY_OFF: 'Confirm your schedule and add a payment method. Rent autopay is off, so you’ll tell us each month you want to use Flex.'
    },
    PAYMENT_METHOD: {
        TITLE: 'Payment method',
        PLACEHOLDER: 'Card info'
    },
    CTA: 'Confirm',
    AUTOPAY_OFF_DISCLAIMER: 'Don’t worry, we won’t charge you until tell us to.',
    AUTHORIZATION_AGREEMENT: 'I authorize Flex to charge my card according to this payment schedule and understand that the amounts are estimates and may vary.'
};
exports.CLASSIC_SLC_CONFIRM_SCHEDULE_CONTENT = __assign(__assign({}, exports.SLC_CONFIRM_SCHEDULE_CONTENT), { HEADER: 'Finalize your payment schedule', SUB_HEADER: 'We’ll start processing your rent payments beginning with your {{month}} {{year}} bill.' });
exports.FA_SLC_CONFIRM_SCHEDULE_CONTENT = __assign(__assign({}, exports.SLC_CONFIRM_SCHEDULE_CONTENT), { HEADER: 'Finalize your payment schedule', SUB_HEADER: 'You can start splitting your rent payments beginning with your {{month}} {{year}} bill.' });
exports.SLC_AGREEMENTS_MODAL_CONTENT = {
    HEADER: 'Complete signup',
    SUB_HEADER: 'One last thing—please accept our membership policies to start using the Flex app.',
    AGREEMENT: 'I have reviewed and agree to the documents above',
    CTA: 'Accept'
};
exports.SLC_CLASSIC_AGREEMENTS_CONTENT = {
    HEADER: 'Complete signup',
    SUB_HEADER: 'To finish signing up, just review the following legal information.',
    AGREEMENT: 'By choosing ‘Accept’, I agree to:',
    CTA: 'Accept'
};
